module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "detail-product d-flex space-between"
  }, [_c('div', {
    staticClass: "detail-product-slider"
  }, [_c('div', {
    staticClass: "wrapper-image-slider"
  }, [_c('swiper', {
    ref: "swiperTop",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.productDetail.images), function(image, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "wrapper-image"
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": image.urlImage,
        "alt": image.name
      }
    })])
  }))], 1), _vm._v(" "), _c('swiper', {
    ref: "swiperThumbs",
    staticClass: "wrapper-thumbs mt-2",
    attrs: {
      "options": _vm.swiperOptionThumbs
    }
  }, _vm._l((_vm.productDetail.images), function(image, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "image-thumbs"
    }, [_c('img', {
      staticClass: "thumbs",
      attrs: {
        "src": image.urlImage,
        "alt": image.name
      },
      on: {
        "click": function($event) {
          _vm.toSlide(index)
        }
      }
    })])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-product-description"
  }, [_c('div', {
    staticClass: "wrapper-section space-between",
    style: (("border-top: 0.1rem solid " + (_vm.globalColors.border) + ";"))
  }, [_c('div', [_c('p', {
    staticClass: "m-0 text-description"
  }, [_vm._v(_vm._s(_vm.productDetail.description))]), _vm._v(" "), _c('p', {
    staticClass: "m-0 text-description pb-1"
  }, [_vm._v("#" + _vm._s(_vm.productDetail.code))])]), _vm._v(" "), _c('div', [_c('heart-svg', {
    attrs: {
      "active": _vm.productDetail.flagFavorite
    },
    on: {
      "click": _vm.addToFavorites
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-section wrapper-padding space-between justify-center",
    style: (("border-bottom: 0.1rem solid " + (_vm.globalColors.border) + ";"))
  }, [_c('div', [_c('p', {
    staticClass: "text-price-now m-0 txt-center",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v(" " + _vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.productDetail.priceDiscount)))]), _vm._v(" "), _c('p', {
    staticClass: "text-price-before m-0 txt-center"
  }, [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.productDetail.price)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column align-center justify-center"
  }, [_c('el-rate', {
    staticClass: "mt-2",
    attrs: {
      "colors": _vm.colors,
      "disabled": ""
    },
    model: {
      value: (_vm.productDetail.rating),
      callback: function($$v) {
        _vm.$set(_vm.productDetail, "rating", $$v)
      },
      expression: "productDetail.rating"
    }
  })], 1)]), _vm._v(" "), _c('ProductConversion', {
    attrs: {
      "default-unit": _vm.productDetail.unit,
      "conversions": _vm.productDetail.conversions
    },
    on: {
      "unit-selection": _vm.unitSelection
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper-section wrapper-padding space-between align-center",
    style: (("border-bottom: 0.1rem solid " + (_vm.globalColors.border) + ";"))
  }, [_c('div', {
    staticClass: "wrapper-counter-general"
  }, [_c('p', {
    staticClass: "title-counter"
  }, [_vm._v("Cantidad")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex wrapper-counter"
  }, [_c('button', {
    staticClass: "counter-sign d-flex align-center justify-center border-counter",
    style: (("color:" + (_vm.globalColors.primary))),
    on: {
      "click": function($event) {
        _vm.changeQuantity('less')
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "counter-number d-flex align-center justify-center border-counter"
  }, [_vm._v(_vm._s(_vm.productDetail.quantity))]), _vm._v(" "), _c('button', {
    staticClass: "counter-sign d-flex align-center justify-center",
    style: (("color:" + (_vm.globalColors.primary))),
    on: {
      "click": function($event) {
        _vm.changeQuantity('more')
      }
    }
  }, [_vm._v("+")])])])]), _vm._v(" "), _c('features-button', {
    staticClass: "wrapper-features",
    attrs: {
      "features": _vm.features
    },
    on: {
      "select": _vm.selectFeature
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper-buttons d-flex"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      'disabled-btn': _vm.noStock
    },
    style: (("background-color:" + (_vm.globalColors.primary))),
    on: {
      "click": _vm.buy
    }
  }, [_vm._v("Comprar Ahora")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'disabled-btn': _vm.noStock
    },
    style: (("background-color:" + (_vm.globalColors.hover))),
    on: {
      "click": _vm.addToCar
    }
  }, [_vm._v("Añadir a Carrito")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'disabled-btn': _vm.noStock
    },
    style: (("background-color:" + (_vm.globalColors.titulo))),
    attrs: {
      "disabled": _vm.disabledBtn
    },
    on: {
      "click": _vm.productsInWarehouses
    }
  }, [_vm._v("Verificar Stock")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b10510","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/detail/product.vue
// module id = 1094
// module chunks = 1